import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { Palette } from "../../../../core/styles/palette";
import type { RevisionType } from "../types/Dashboard";

dayjs.extend(relativeTime);

export const formatUptime = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    const parts: string[] = [];

    if (days > 0) {
        parts.push(`${days} day${days !== 1 ? "s" : ""}`);
    }
    if (hours > 0) {
        parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    }
    if (minutes > 0 || parts.length === 0) {
        parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
    }

    return parts.join(" ");
};

export const formatRelativeTime = (dateTime: string): string => {
    return dayjs(dateTime).fromNow();
};

export const getRevisionTypeColor = (type: RevisionType): string => {
    const revisionColors: Record<RevisionType, string> = {
        INSERT: Palette.HeroGreen,
        UPDATE: "#1890ff", // Blue
        DELETE: Palette.AeviRed,
        LOGIN: "#8c8c8c", // Gray
        LOGOUT: "#8c8c8c", // Gray
    };

    return revisionColors[type] || "#8c8c8c";
};

export const formatDateTime = (dateTime: string): string => {
    return dayjs(dateTime).format("DD.MM.YYYY HH:mm");
};
